import { motion, useScroll, useSpring } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { scrollToJoin } from "@/App";

export const Nav = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24 });

  return (
    <header
      data-testid="sticky-nav"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-white/40 shadow-sm"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#" data-testid="nav-logo" className="flex items-center gap-2.5" aria-label="ProofBuy home">
          <span className="w-8 h-8 rounded-lg bg-trust flex items-center justify-center">
            <ShieldCheck className="w-4.5 h-4.5 text-white" size={18} />
          </span>
          <span className="font-display font-bold text-lg tracking-tight">ProofBuy</span>
        </a>
        <button
          data-testid="nav-early-access-button"
          onClick={scrollToJoin}
          className="rounded-full bg-trust text-white text-sm font-semibold px-5 py-2.5 transition-colors duration-200 hover:bg-trust-dark"
        >
          Get early access
        </button>
      </div>
      <motion.div
        data-testid="scroll-progress-bar"
        className="absolute bottom-0 left-0 right-0 h-[2px] bg-trust origin-left"
        style={{ scaleX }}
      />
    </header>
  );
};
